import { render, staticRenderFns } from "./SameAs.vue?vue&type=template&id=31fdb1c1&lang=pug&"
import script from "./SameAs.vue?vue&type=script&lang=ts&"
export * from "./SameAs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports